// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__11udc","select":"Header_select__1IIJ6","clinic":"Header_clinic__2ijXo"};